import {
  Box,
  Button,
  Checkbox,
  ClickAwayListener,
  FormControlLabel,
  FormGroup,
  FormLabel,
  Grid,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  Stack,
  Tooltip,
  Typography,
} from "@mui/material";
// import HipShipGreen from "../assests/logo/hipship.png";
import HipShipGreen from "../assests/logo/hipShipGreen.png";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useEffect, useState } from "react";
import {
  GetStateByPincode,
  UserRegister,
  UserShopifyRegister,
} from "../config/api";
import Zoom from "@mui/material/Zoom";
import { StyledInput } from "../components/ui/StyledInput";
import styled from "styled-components";
import { StyledSeperator } from "../components/ui/Seperator";
import toast from "react-hot-toast";
import { StyledButton } from "../components/ui/StyledButton";

interface FormData {
  username: string;
  email: string;
  password: string;
  mobile: string;
  address: string;
  user_type: string;
  city: string;
  state: string;
  pincode: string;
  business_account_type: string;
  transport_type: string;
  company_name: string;
  pan_number: string;
  business_type: string;
  shipment_volume: string;
  // cname: string;
  fname: string;
  Lname: string;
  gst_on: string;
}

const StyledSelect = styled(Select)`
  margin-top: 8px !important;

  > div {
    padding: 6px 8px !important;
  }
`;

const Register = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [isShopify, setIsShopify] = useState(false);

  useEffect(() => {
    const channelFromParams = searchParams.get("channel");

    if (channelFromParams === "shopify") {
      setIsShopify(true);
    }
  }, [searchParams]);

  const [formData, setFormData] = useState<FormData>({
    email: "",
    password: "",
    username: "",
    mobile: "",
    address: "",
    user_type: "",
    city: "",
    state: "",
    pincode: "",
    business_account_type: "",
    transport_type: "",
    company_name: "",
    pan_number: "",
    business_type: "",
    shipment_volume: "",
    // cname: "",
    fname: "",
    Lname: "",
    gst_on: "",
  });

  const [passwordTool, setpasswordTool] = useState({
    field: false,
    upper: false,
    lower: false,
    special: false,
  });

  const [isError, setIsError] = useState({
    email: "",
    user: "",
    password: "",
    mobile: "",
    pincode: "",
    pan_number: "",
    gst_on: "",
    city: "",
  });

  const [city, setCity] = useState("Select City");
  const [state, setState] = useState("Select State");

  const passwordLength = (value: string, limit: number) =>
    value.slice(0, limit);

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;

    if (name === "password") {
      setFormData({ ...formData, [name]: passwordLength(value, 8) });
    } else {
      setFormData({ ...formData, [name]: value });
    }

    if (name === "pincode") {
      if (value.length >= 6) {
        const test = GetStateByPincode(value)
          .then((data) => {
            setCity(data.data.data.city);
            setState(data.data.data.state);

            const updatedError = { ...isError, pincode: "" };
            setIsError(updatedError);
          })
          .catch((error) => {
            const updatedError = {
              ...isError,
              pincode: error.response.data.message,
            };
            setIsError(updatedError);
          });
      } else {
        setCity("Select City");
        setState("Select State");
      }
    }
  };

  useEffect(() => {
    handlePassword(formData.password);
  }, [formData.password]);

  const handlePassword = (password: string) => {
    let updatedPasswordTool = { ...passwordTool };

    if (password.length === 8) {
      updatedPasswordTool = { ...updatedPasswordTool, field: true };
    } else {
      updatedPasswordTool = { ...updatedPasswordTool, field: false };
    }

    if (containsUppercase(password)) {
      updatedPasswordTool = { ...updatedPasswordTool, upper: true };
    } else {
      updatedPasswordTool = { ...updatedPasswordTool, upper: false };
    }

    if (hasLowerCase(password)) {
      updatedPasswordTool = { ...updatedPasswordTool, lower: true };
    } else {
      updatedPasswordTool = { ...updatedPasswordTool, lower: false };
    }

    if (containsSpecialChars(password)) {
      updatedPasswordTool = { ...updatedPasswordTool, special: true };
    } else {
      updatedPasswordTool = { ...updatedPasswordTool, special: false };
    }

    setpasswordTool(updatedPasswordTool);
  };

  function containsUppercase(str: string) {
    return /[A-Z]/.test(str);
  }

  function hasLowerCase(str: string) {
    return /[a-z]/.test(str);
  }

  function containsSpecialChars(str: string) {
    const specialChars = /[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
    return specialChars.test(str);
  }
  const [open, setOpen] = useState(false);

  const handleTooltipClose = () => {
    setOpen(false);
  };

  const handleTooltipOpen = () => {
    setOpen(true);
  };

  const validateForm = ({
    email,
    password,
    mobile,
    pincode,
    pan_number,
    gst_on,
    city,
  }: {
    email: string;
    password: string;
    mobile: string;
    pincode: string;
    pan_number: string;
    gst_on: string;
    city: string;
  }) => {
    let errors = {
      email: "",
      user: "",
      password: "",
      mobile: "",
      pincode: "",
      pan_number: "",
      gst_on: "",
      city: "",
    };

    let haveErros = false;

    if (!email) {
      errors.email = "Email is required";
      haveErros = true;
    } else if (!/\S+@\S+\.\S+/.test(email)) {
      errors.email = "Email is invalid";
      haveErros = true;
    }

    if (!password) {
      errors.password = "Password is required";
      haveErros = true;
    } else if (
      passwordTool.field === false ||
      passwordTool.lower === false ||
      passwordTool.special === false ||
      passwordTool.upper === false
    ) {
      errors.password = " ";
      haveErros = true;
      handleTooltipOpen();
    }

    if (!/^\d*$/.test(mobile)) {
      errors.mobile = "Invalid Mobile Number";
      haveErros = true;
    } else if (mobile.length !== 10) {
      errors.mobile = "Invalid Mobile Number";
      haveErros = true;
    }

    if (pincode.length !== 6) {
      errors.pincode = "Invalid Pincode";
      haveErros = true;
    }

    if (pan_number.length !== 10) {
      errors.pan_number = "Invalid Pan No";
      haveErros = true;
    }

    if (gst_on.length !== 15) {
      errors.gst_on = "Invalid GST No";
      haveErros = true;
    }

    setIsError(errors);

    return haveErros;
  };

  const navigate = useNavigate();

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const {
      username,
      email,
      password,
      fname,
      Lname,
      mobile,
      address,
      user_type,
      pincode,
      company_name,
      pan_number,
      business_type,
      shipment_volume,
    } = formData;
    console.log(formData);

    if (!validateForm(formData)) {
      if (!isShopify) {
        const user = {
          username: username,
          email: email,
          password: password,
          first_name: fname,
          last_name: Lname,
        };
        UserRegister({
          user,
          mobile,
          address,
          city,
          state,
          user_type,
          pincode,
          company_name,
          pan_number,
          business_type,
          shipment_volume,
        })
          .then(() => {
            toast.success("User Registered! Kindly login");
            navigate("/login");
          })
          .catch((error) => {
            const errorData = error?.response?.data?.message?.user;

            const isErrorDev = isError;

            if (errorData?.email) {
              isError.email = errorData?.email[0];
            }
            if (errorData?.username) {
              isError.user = errorData?.username[0];
            }

            setIsError(isErrorDev);
            console.log(error);
          });
        // navigate("/login");
      } else {
        const user = {
          username: username,
          email: email,
          password: password,
          first_name: fname,
          last_name: Lname,
        };

        const access_token = searchParams.get("access_token") ?? "";
        const channel = searchParams.get("channel") ?? "";
        const shop = searchParams.get("shop") ?? "";
        UserShopifyRegister({
          user,
          mobile,
          address,
          city,
          state,
          user_type,
          pincode,
          company_name,
          pan_number,
          business_type,
          shipment_volume,
          access_token,
          shop,
          channel,
        })
          .then(() => {
            toast.success("User Registered! Kindly login");
            navigate("/login");
          })
          .catch((error) => {
            const errorData = error?.response?.data?.message?.user;
            const isErrorDev = isError;
            if (errorData?.email) {
              isError.email = errorData?.email[0];
            }
            if (errorData?.username) {
              isError.user = errorData?.username[0];
            }

            setIsError(isErrorDev);
            console.log(error);
          });
      }
    }
  };

  const [canSubmit, setCanSubmit] = useState(false);

  const enableSubmitButton = () => {
    if (
      formData.username &&
      formData.password &&
      formData.mobile &&
      formData.fname &&
      formData.Lname &&
      formData.email &&
      formData.pan_number &&
      formData.pincode &&
      formData.address &&
      // formData.cname &&
      formData.company_name &&
      formData.shipment_volume &&
      formData.gst_on
    ) {
      setCanSubmit(true);
    }
    if (
      formData.username == "" ||
      formData.password == "" ||
      formData.mobile == "" ||
      formData.fname == "" ||
      formData.Lname == "" ||
      formData.email == "" ||
      formData.pan_number == "" ||
      formData.pincode == "" ||
      formData.address == "" ||
      formData.company_name == "" ||
      formData.shipment_volume == "" ||
      formData.gst_on == ""
    ) {
      setCanSubmit(false);
    }
  };

  useEffect(() => {
    enableSubmitButton();
  }, [formData]);

  const [type, setType] = useState("password");
  const showPassword = () => {
    if (type === "text") setType("password");
    if (type === "password") setType("text");
  };

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  return (
    <div
      style={{
        width: "100%",
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "#f5f7fa",
      }}
    >
      <Stack
        flexDirection={"row"}
        justifyContent={"space-around"}
        alignItems={"center"}
        width={"100%"}
      >
        <Box
          sx={{
            display: `${windowWidth < 1100 ? "none" : ""}`,
          }}
        >
          <div
            style={{
              width: "180px",
              marginBottom: "20px",
            }}
          >
            <img width={"100%"} src={HipShipGreen} alt="" draggable={false} />
          </div>

          <Typography
            fontWeight={700}
            lineHeight={1.2}
            fontStyle={"italic"}
            fontSize={"36px"}
          >
            We Are More than Just a <br />
            Shipping Partner.
          </Typography>
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "#fff",
            gap: "20px",
            borderRadius: "10px",
            width: "600px",
            boxShadow: "1px 2px 10px 0px rgba(0, 0, 0, 0.2)",
            overflowY: "scroll",
            height: "80vh",
          }}
        >
          <Box
            sx={{
              height: "100%",
              padding: "40px 40px",
            }}
          >
            <form onSubmit={handleSubmit}>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Typography
                    fontWeight={700}
                    fontSize={"24px"}
                    textAlign={"center"}
                  >
                    Get started with a free account
                  </Typography>
                  <StyledSeperator
                    style={{
                      marginBottom: 0,
                    }}
                  />
                </Grid>

                <Grid item xs={6}>
                  <FormLabel>
                    <Typography fontSize={12}>Username</Typography>
                  </FormLabel>
                  <StyledInput
                    sx={{
                      borderRadius: "10px",
                    }}
                    id="username"
                    name="username"
                    fullWidth
                    value={formData.username}
                    onChange={handleInputChange}
                    error={Boolean(isError.user)}
                    focused={Boolean(isError.user)}
                    helperText={isError.user && isError.user}
                    // error={Boolean(isError.username)}
                    // focused={Boolean(isError.username)}
                    // helperText={isError.username && isError.username}
                  />
                </Grid>

                <Grid item xs={6}>
                  <FormLabel>
                    <Typography fontSize={12}>Fname</Typography>
                  </FormLabel>
                  <StyledInput
                    sx={{
                      borderRadius: "10px",
                    }}
                    id="fname"
                    name="fname"
                    fullWidth
                    onChange={handleInputChange}

                    // value={formData.username}
                    // onChange={handleInputChange}
                    // error={Boolean(isError.username)}
                    // focused={Boolean(isError.username)}
                    // helperText={isError.username && isError.username}
                  />
                </Grid>

                <Grid item xs={6}>
                  <FormLabel>
                    <Typography fontSize={12}>Lname</Typography>
                  </FormLabel>
                  <StyledInput
                    sx={{
                      borderRadius: "10px",
                    }}
                    id="Lname"
                    name="Lname"
                    fullWidth
                    onChange={handleInputChange}
                  />
                </Grid>

                <Grid item xs={6}>
                  <FormLabel>
                    <Typography fontSize={12}>Email</Typography>
                  </FormLabel>
                  <StyledInput
                    sx={{
                      borderRadius: "10px",
                    }}
                    fullWidth
                    id="email"
                    name="email"
                    autoComplete="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    error={Boolean(isError.email)}
                    focused={Boolean(isError.email)}
                    helperText={isError.email && isError.email}
                  />
                </Grid>

                <Grid item xs={6}>
                  <FormLabel>
                    <Typography fontSize={12}>Mobile</Typography>
                  </FormLabel>
                  <StyledInput
                    sx={{
                      borderRadius: "10px",
                    }}
                    id="mobile"
                    name="mobile"
                    type="int"
                    fullWidth
                    value={formData.mobile}
                    onChange={handleInputChange}
                    error={Boolean(isError.mobile)}
                    focused={Boolean(isError.mobile)}
                    helperText={isError.mobile && isError.mobile}
                  />
                </Grid>

                <Grid item xs={6}>
                  <FormLabel>
                    <Typography fontSize={12}>Pan Number</Typography>
                  </FormLabel>
                  <StyledInput
                    sx={{
                      borderRadius: "10px",
                    }}
                    id="pan_number"
                    name="pan_number"
                    fullWidth
                    value={formData.pan_number}
                    onChange={handleInputChange}
                    error={Boolean(isError.pan_number)}
                    focused={Boolean(isError.pan_number)}
                    helperText={isError.pan_number && isError.pan_number}
                  />
                </Grid>

                <Grid item xs={12}>
                  <div>
                    <FormLabel>
                      <Typography fontSize={12}>Pincode</Typography>
                    </FormLabel>
                    <StyledInput
                      sx={{
                        borderRadius: "10px",
                      }}
                      id="pincode"
                      name="pincode"
                      inputProps={{
                        maxLength: 6,
                      }}
                      fullWidth
                      value={formData.pincode}
                      onChange={handleInputChange}
                      error={Boolean(isError.pincode)}
                      focused={Boolean(isError.pincode)}
                      helperText={isError.pincode && isError.pincode}
                    />
                  </div>
                </Grid>

                <Grid item xs={6}>
                  <FormLabel>
                    <Typography fontSize={12}>City</Typography>
                  </FormLabel>
                  <StyledSelect
                    name="city"
                    id="city"
                    value={0}
                    sx={{
                      width: "100%",
                      padding: 0,
                    }}
                    error={Boolean(isError.city)}
                  >
                    <MenuItem value={0}>
                      <Typography fontSize={12}>{city}</Typography>
                    </MenuItem>
                  </StyledSelect>
                </Grid>

                <Grid item xs={6}>
                  <FormLabel>
                    <Typography fontSize={12}>State</Typography>
                  </FormLabel>
                  <StyledSelect
                    value={0}
                    sx={{
                      width: "100%",
                    }}
                  >
                    <MenuItem value={0}>
                      <Typography fontSize={12}>{state}</Typography>
                    </MenuItem>
                  </StyledSelect>
                </Grid>
                <Grid item xs={12}>
                  <FormLabel>
                    <Typography fontSize={12}>Address</Typography>
                  </FormLabel>
                  <StyledInput
                    sx={{
                      borderRadius: "10px",
                    }}
                    id="address"
                    name="address"
                    fullWidth
                    onChange={handleInputChange}
                  />
                </Grid>

                <Grid item xs={6}>
                  <FormLabel>
                    <Typography fontSize={12}>Company Name</Typography>
                  </FormLabel>
                  <StyledInput
                    sx={{
                      borderRadius: "10px",
                    }}
                    id="company_name"
                    name="company_name"
                    fullWidth
                    onChange={handleInputChange}
                  />
                </Grid>

                <Grid item xs={6}>
                  <FormLabel>
                    <Typography fontSize={12}>Shipment Value</Typography>
                  </FormLabel>
                  <StyledInput
                    sx={{
                      borderRadius: "10px",
                    }}
                    id="shipment_volume"
                    name="shipment_volume"
                    fullWidth
                    onChange={handleInputChange}
                  />
                </Grid>

                <Grid item xs={6}>
                  <FormLabel>
                    <Typography fontSize={12}>Gst no.</Typography>
                  </FormLabel>
                  <StyledInput
                    sx={{
                      borderRadius: "10px",
                    }}
                    id="gst_on"
                    name="gst_on"
                    fullWidth
                    value={formData.gst_on}
                    onChange={handleInputChange}
                    error={Boolean(isError.gst_on)}
                    focused={Boolean(isError.gst_on)}
                    helperText={isError.gst_on && isError.gst_on}
                  />
                </Grid>

                <Grid item xs={6}>
                  <FormLabel>
                    <Typography fontSize={12}>Password</Typography>
                  </FormLabel>
                  <ClickAwayListener onClickAway={handleTooltipClose}>
                    <Tooltip
                      PopperProps={{
                        disablePortal: true,
                      }}
                      onClose={handleTooltipClose}
                      open={open}
                      disableFocusListener
                      disableHoverListener
                      disableTouchListener
                      TransitionComponent={Zoom}
                      title={
                        <>
                          <Typography
                            color={passwordTool.field ? "green" : "red"}
                            fontSize={"12px"}
                          >
                            Password must be of 8 characters.
                          </Typography>
                          <Typography
                            color={passwordTool.upper ? "green" : "red"}
                            fontSize={"12px"}
                          >
                            Password must contain at least 1 uppercase letter.
                          </Typography>
                          <Typography
                            color={passwordTool.lower ? "green" : "red"}
                            fontSize={"12px"}
                          >
                            Password must contain at least 1 lowercase letter.
                          </Typography>
                          <Typography
                            color={passwordTool.special ? "green" : "red"}
                            fontSize={"12px"}
                          >
                            Password must contain at least 1 special character.
                          </Typography>
                        </>
                      }
                      placement="left"
                      componentsProps={{
                        tooltip: {
                          sx: {
                            border: "0.5px solid #cacaca",
                            backgroundColor: "#f5f7fa",
                            // backgroundColor: "#b7e5d5",
                            color: "white",
                            padding: "10px",
                          },
                        },
                      }}
                    >
                      <StyledInput
                        sx={{
                          borderRadius: "10px",
                        }}
                        fullWidth
                        id="password"
                        name="password"
                        type={type}
                        value={formData.password}
                        onChange={handleInputChange}
                        onClick={handleTooltipOpen}
                        error={Boolean(isError.password)}
                        focused={Boolean(isError.password)}
                        helperText={isError.password && isError.password}
                      />
                    </Tooltip>
                  </ClickAwayListener>

                  <FormGroup onChange={showPassword}>
                    <FormControlLabel
                      control={<Checkbox size="small" />}
                      label={
                        <Typography fontSize={12}>Show Password</Typography>
                      }
                    />
                  </FormGroup>
                </Grid>
                <Grid item xs={4}>
                  <FormLabel>
                    <Typography fontSize={12}>Business Type</Typography>
                  </FormLabel>
                  <RadioGroup
                    row
                    aria-labelledby="demo-row-radio-buttons-group-label"
                    name="business_type"
                  >
                    <Stack direction={"row"}>
                      <FormControlLabel
                        value="B2B"
                        control={<Radio size="small" />}
                        label={<Typography fontSize={12}>B2B</Typography>}
                      />
                      <FormControlLabel
                        value="B2C"
                        control={<Radio size="small" />}
                        label={<Typography fontSize={12}>B2C</Typography>}
                      />
                    </Stack>
                  </RadioGroup>
                </Grid>

                <Grid item xs={12}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <StyledButton
                      type="submit"
                      variant="contained"
                      disabled={!canSubmit}
                    >
                      Sign up
                    </StyledButton>
                  </div>
                </Grid>

                <Grid item xs={12}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <Link to="/login">
                      <Button
                        style={{
                          textTransform: "initial",
                          margin: "16px 0",
                          color: "indigo[500]",
                        }}
                      >
                        Already have an account?
                      </Button>
                    </Link>
                  </div>
                </Grid>
              </Grid>
            </form>
          </Box>
        </Box>
      </Stack>
    </div>
  );
};

export default Register;
